import { NFLWeekAbbreviation, NFLWeekId } from './nfl/nfl-week'

// I don't want to add NFLWeekAbbreviation 28-32 to the enum since they are IDs so ignore is needed
// @ts-ignore
const NFL_WEEK_ABBR_MAP: Record<NFLWeekAbbreviation, NFLWeekId> = {
  [NFLWeekAbbreviation.PreseasonWeek4]: NFLWeekId.PreseasonWeek4,
  [NFLWeekAbbreviation.PreseasonWeek3]: NFLWeekId.PreseasonWeek3,
  [NFLWeekAbbreviation.PreseasonWeek2]: NFLWeekId.PreseasonWeek2,
  [NFLWeekAbbreviation.PreseasonWeek1]: NFLWeekId.PreseasonWeek1,
  [NFLWeekAbbreviation.HallOfFame]: NFLWeekId.HallOfFame,
  [NFLWeekAbbreviation.Week1]: NFLWeekId.Week1,
  [NFLWeekAbbreviation.Week2]: NFLWeekId.Week2,
  [NFLWeekAbbreviation.Week3]: NFLWeekId.Week3,
  [NFLWeekAbbreviation.Week4]: NFLWeekId.Week4,
  [NFLWeekAbbreviation.Week5]: NFLWeekId.Week5,
  [NFLWeekAbbreviation.Week6]: NFLWeekId.Week6,
  [NFLWeekAbbreviation.Week7]: NFLWeekId.Week7,
  [NFLWeekAbbreviation.Week8]: NFLWeekId.Week8,
  [NFLWeekAbbreviation.Week9]: NFLWeekId.Week9,
  [NFLWeekAbbreviation.Week10]: NFLWeekId.Week10,
  [NFLWeekAbbreviation.Week11]: NFLWeekId.Week11,
  [NFLWeekAbbreviation.Week12]: NFLWeekId.Week12,
  [NFLWeekAbbreviation.Week13]: NFLWeekId.Week13,
  [NFLWeekAbbreviation.Week14]: NFLWeekId.Week14,
  [NFLWeekAbbreviation.Week15]: NFLWeekId.Week15,
  [NFLWeekAbbreviation.Week16]: NFLWeekId.Week16,
  [NFLWeekAbbreviation.Week17]: NFLWeekId.Week17,
  [NFLWeekAbbreviation.Week18]: NFLWeekId.Week18,
  [NFLWeekAbbreviation.Wildcard]: NFLWeekId.Wildcard,
  [NFLWeekAbbreviation.DivisionalPlayoff]: NFLWeekId.DivisionalPlayoff,
  [NFLWeekAbbreviation.ConferenceChampionship]: NFLWeekId.ConferenceChampionship,
  [NFLWeekAbbreviation.SuperBowl]: NFLWeekId.SuperBowl,
}

export function getWeekId(weekAbbr: string): number | null {
  const upperCaseWeekAbbr = weekAbbr.toUpperCase()
  const weekId = NFL_WEEK_ABBR_MAP[upperCaseWeekAbbr as NFLWeekAbbreviation]
  return weekId || null
}
